import React from 'react';
import { Button as MuiButton } from '@mui/material';

export default function Button({ children, variant = 'contained', ...rest }) {
  return (
    <MuiButton variant={variant} size="medium" {...rest}>
      {children}
    </MuiButton>
  );
}
